<template>
    <div id="component-chat-log" class="m-8" v-if="chatData">
      <div v-for="(msg, index) in chatData.msg" class="msg-grp-container" :key="index">
        <!-- If previous msg is older than current time -->
        <template v-if="chatData.msg[index-1]">
          <vs-divider v-if="!isSameDay(msg.time, chatData.msg[index-1].time)" class="msg-time">
            <span>{{ toDate(msg.time) }}</span>
          </vs-divider>
          <div class="spacer mt-8" v-if="!hasSentPreviousMsg(chatData.msg[index-1].isSent, msg.isSent)"></div>
        </template>

        <div class="flex items-start" :class="[{'flex-row-reverse' : !msg.isSent}]">

          <template v-if="chatData.msg[index-1]">
            <template v-if="(!hasSentPreviousMsg(chatData.msg[index-1].isSent, msg.isSent) || !isSameDay(msg.time, chatData.msg[index-1].time))">
              <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 mt-2 flex-shrink-0" :class="msg.isSent ? 'sm:mr-5 mr-3' : 'sm:ml-5 ml-3'" :src="senderImg(msg.isSent)" @click.stop="viewProfile(msg.isSent?user.id:userId)"></vs-avatar>
            </template>
          </template>

          <template v-if="index == 0">
            <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 mt-2 flex-shrink-0" :class="msg.isSent ? 'sm:mr-5 mr-3' : 'sm:ml-5 ml-3'" :src="senderImg(msg.isSent)" @click.stop="viewProfile(msg.isSent?user.id:userId)"></vs-avatar>
          </template>

          <template v-if="chatData.msg[index-1]">
            <div class="mr-16" v-if="!(!hasSentPreviousMsg(chatData.msg[index-1].isSent, msg.isSent) || !isSameDay(msg.time, chatData.msg[index-1].time))"></div>
          </template>

          <div>
            <vx-tooltip :text="msg.time | time" :position="msg.isSent ? 'left' : 'right'"
                        class="msg select-text break-words relative shadow-md rounded py-3 px-4 mt-2 rounded-lg max-w-sm"
                        :class="{'bg-primary-gradient text-white': msg.isSent, 'border border-solid border-grey-light bg-white': !msg.isSent, 'opacity-50': msg.status === 'sending', 'bg-danger-gradient': msg.status === 'error'}">
              {{ msg.textContent }}
            </vx-tooltip>

            <vx-tooltip v-if="lastSeen && lastSeen.time === msg.time && msg.isSent" :text="msg.time | date_time"  :position="msg.isSent ? 'left' : 'right'" class="flex items-center mt-1">
              <span>تمت القراءة عند {{msg.readAt | time}}</span>
              <feather-icon icon="CheckIcon" svg-classes="h-4 w-4 ml-2" />
            </vx-tooltip>

            <p v-if="msg.status === 'error'" @click="$emit('resend', msg)" class="flex items-center text-danger mt-1 cursor-pointer">
              <span>إعادة الإرسال</span>
              <feather-icon icon="RotateCwIcon" svg-classes="h-4 w-4 ml-2" />
            </p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default{
    props: {
        userId: {
            type: Number,
            required: true,
        },
        preventScrollDown: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        lastSeen(){
              return this.chatData.msg.slice().reverse().find(msg => msg.isSeen && msg.isSent)
        },
        chatData() {
            return this.$store.getters['chat/chatDataOfUser'](this.userId)
        },
        activeUserImg() {
            return this.$store.state.AppActiveUser.image;
        },
        senderImg() {
            return (isSentByActiveUser) => {
                if (isSentByActiveUser) return this.user.image
                else return this.$store.getters['chat/contact'](this.userId).image
            }
        },
        hasSentPreviousMsg() {
            return (last_sender, current_sender) => last_sender == current_sender
        },
    },
    methods: {
        isSameDay(time_to, time_from) {
            const date_time_to = new Date(Date.parse(time_to))
            const date_time_from = new Date(Date.parse(time_from));
            return date_time_to.getFullYear() === date_time_from.getFullYear() &&
                date_time_to.getMonth() === date_time_from.getMonth() &&
                date_time_to.getDate() === date_time_from.getDate();
        },
        toDate(time) {
            const locale = "ar-ly";
            const date_obj = new Date(Date.parse(time));
            const monthName= date_obj.toLocaleString(locale, {
                month: 'short'
            });
            return date_obj.getDate() + ' '  + monthName;
        },
        scrollToBottom() {
            this.$nextTick(() => {
                this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight
            });
        },
    },
    updated() {
        if(!this.preventScrollDown) {
            this.scrollToBottom();
        }
    },
    mounted() {
        this.scrollToBottom();
    }
}
</script>
